import get from 'lodash/get';
import isObject from 'lodash/isObject';
import {applyAutoFilter, ReduxList} from '../../_libs/redux-observable-list';
import {sortByPropertyAccessor} from '../../core-utilities/filters/filterUtils';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {SYNC_PATH} from '../../core-utilities/rx-utils';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {buildUserChannelSyncNotifier} from '../../auth/utils/redux-lists';
import {getUserSubscriptions} from '../reducers/state';
import {logger} from './logger';
import {USER_SUBSCRIPTIONS_LIST_PREFIX} from './state';


// TODO: replace next API with standard after first release cycle
const resourcePath = `next/chat-channels`;

const matchesAutoFilter = applyAutoFilter(['name', 'metadata.parentName'], 1);

export const reduxList = new ReduxList({
  ...BASE_REDUX_LIST_OPTIONS,
  prefix: USER_SUBSCRIPTIONS_LIST_PREFIX,
  getState: getUserSubscriptions,
  pageSize: 100,
  hasParentId: false,
  useDelete: true,
  useFiltering: true,
  useAutoFilter: true,
  useFilterOptions: false,
  useSortOptions: false,
  applySortOptions,
  defaultSortOptions: {},
  isVisible,
  syncNotifier: buildUserChannelSyncNotifier('chat-channels'),
  listPath: resourcePath,
  listSyncPath: `${resourcePath}/${SYNC_PATH}`,
  deleteItemPath: channelId => `chat-channels/${channelId}/subscription`,
  logger,

  // cacheOptions: {
  //   localForage: asyncStorage,
  //   key: targetOptions.cacheName,
  // },
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options);

function isVisible(item, filterData) {
  if (!isObject(item)) return false;
  if (!matchesAutoFilter(item, filterData.filter)) return false;
}

export function applySortOptions(list) {
  return list.sort(sortByPropertyAccessor(getLastUpdatedDate, false, true));
}

// sort by date, newest first
function getLastUpdatedDate(item) {
  if (item) {
    return get(item, 'latestComment.date', item.lastUpdated);
  }
}



// WEBPACK FOOTER //
// ./src/js/comments/redux/userSubscriptions.js